import {createTZDate, wrangleMoment} from './date';


export const getDurationInMinutes = (duration: {
  amount: number;
  unit: string;
}): number => {
  switch (duration.unit) {
    case 'minutes':
      return duration.amount;
    case 'hours':
      return duration.amount * 60;
    case 'days':
      return duration.amount * 24 * 60;
    default:
      return 0;
  }
};

export const getTimeUntilMeetingHours = (
  eventStart: string | Date | undefined,
  timezone: string | undefined,
): number => {
  const eventDate =
    eventStart && timezone
      ? createTZDate(eventStart, timezone)
      : wrangleMoment(eventStart);
  const now = new Date();
  const timeUntilMeeting = eventDate.getTime() - now.getTime();
  return timeUntilMeeting / (1000 * 60 * 60);
};
